'use client';

/**
 * Skeleton overlay when `skeleton` is true. Does not infer loading from mount time
 * (so images, audio, and tables are not blank until timeout). Use local state in H1 if you want a mount delay.
 */
export function useDeferredSkeleton(skeleton: boolean | undefined, _skeletonMaxWaitMs?: number): boolean {
  return Boolean(skeleton);
}
